import IcCirclePartial from '@/assets/icons/CirclePartial.svg?react';
import styles from './Spinner.module.scss';

const Spinner = () => (
  <IcCirclePartial className={styles.spinner} aria-hidden="true" />
);

export default Spinner;
